import {useStaticAssetsUrl} from "@tinct/core-utils";

export const TinctLogo = ({
  className,
}: {
  className?: string;
}) => {
  const assetsUrl = useStaticAssetsUrl();
  // Figma dimensions: 90.552px × 32px
  // Icon: 32px × 32px (1:1)
  // Text: 50.554px × 19.368px (2.61:1)
  // Gap: ~8px between icon and text
  return (
    <div
      className={`flex h-[32px] items-center gap-2 flex-row ${className ?? ''}`}
    >
      {/* Icon - 35.34% of width, full height */}
      <img
        src={`${assetsUrl}/img/tinct-logo-icon.png`}
        alt=""
        className="h-full w-auto"
      />
      {/* Text - 55.83% of width, centered vertically */}
      <img
        src={`${assetsUrl}/img/tinct-logo-text.svg`}
        alt="tinct"
        className="w-12 h-5 "
      />
    </div>
  );
};
